import React from 'react';
import { Button } from '../../../components/ui/button';
import { BadgeCheck, Clock, PhoneOutgoing } from 'lucide-react';

export function PlantillaBadge() {
  return (
    <div className="flex w-fit items-center gap-1 mb-1.5 px-2 py-0.5 rounded-full bg-emerald-600 text-white text-[10px] font-medium"
      data-testid="crm-badge-plantilla">
      <BadgeCheck className="w-3 h-3" /> Enviado con plantilla aprobada de WhatsApp
    </div>
  );
}

export function PlantillaDetalle({ meta }) {
  const vars = meta.plantilla?.variables || {};
  const filas = [
    ['Destinatario', vars['1'] !== meta.matriculade ? vars['1'] : null],
    ['Matriculade', meta.matriculade || vars['1']],
    ['Matrícula', meta.matricula],
  ].filter(([, v]) => v);
  if (!filas.length && !meta.link) return null;
  return (
    <div className="mt-2 pt-2 border-t border-indigo-200 text-[11px] space-y-0.5" data-testid="crm-plantilla-detalle">
      <p className="opacity-60 uppercase tracking-wide text-[9px]">
        Variables enviadas{meta.plantilla?.nombre ? ` · ${meta.plantilla.nombre}` : ''}
      </p>
      {filas.map(([k, v]) => <p key={k}><span className="opacity-60">{k}:</span> {v}</p>)}
      {meta.link && (
        <p className="truncate"><span className="opacity-60">Link:</span>{' '}
          <a href={meta.link} target="_blank" rel="noreferrer" className="underline break-all">{meta.link}</a>
        </p>
      )}
    </div>
  );
}

export function VentanaCerradaNota({ automatica, onTemplate }) {
  return (
    <div className="pt-6 pb-2 flex justify-center" data-testid="crm-aviso-ventana-cerrada">
      <div className="max-w-md w-full text-center rounded-lg border border-dashed border-slate-300 bg-white/70 px-4 py-3 text-xs text-slate-600">
        <p className="flex items-center justify-center gap-1.5">
          <Clock className="w-3.5 h-3.5 shrink-0" />
          {automatica
            ? 'El sistema envió la notificación automáticamente. Para escribir manualmente, la ventana de 24h está cerrada.'
            : 'La ventana de 24h de WhatsApp está cerrada. Para escribir manualmente, iniciá la conversación con una plantilla.'}
        </p>
        <Button size="sm" variant="outline" className="h-7 text-xs mt-2" onClick={onTemplate} data-testid="crm-btn-plantilla">
          <PhoneOutgoing className="w-3.5 h-3.5 mr-1" /> Iniciar con plantilla
        </Button>
      </div>
    </div>
  );
}
